import { RestrictedRoute } from "../AuthRoute";
import React from "react";

export const generateChildren = routes => {
  return routes.map(route => {
    return convertRouteToRouteur(route);
  });
};

export const convertRouteToRouteur = route => {
  return {
    path: route.path,
    handle: {
      crumb: params => {
        if (route.crumb === undefined) {
          return route.title;
        } else {
          return route.crumb(params);
        }
      },
    },
    index: route.index !== undefined ? route.index : false,
    element: <RestrictedRoute route={route}>{route.element}</RestrictedRoute>,
  };
};
